import { Button, Paragraph } from '@cof/plastic-components';
import { css, styled } from 'styled-components';
import { VisuallyHidden } from '../../../styles/shared';

import Group from '../../Group';
import HeadingLevelOne from '../../HeadingLevelOne';

export const StageHeading = styled(HeadingLevelOne)`
    ${({ theme }: any) => css`
        ${theme.components.StageHeading}
    `}
`;
StageHeading.displayName = 'StageHeading';

export const GroupHeading = styled(HeadingLevelOne)`
    ${({ theme }: any) => css`
        ${theme.components.GroupHeading}
    `}
`;

export const BaseStage = styled.div`
    ${({ theme, $isApplyExperimentStage }: any) => css`
        flex: 1 0 auto;
        width: 100%;
        background-color: ${theme.colors.capitalOne.blue750};
        button {
            min-width: 0;
            ${theme.breakpoints.mq.tabletMin} {
                min-width: 25.6rem;
            }
        }
        ${Group} + ${Group} {
            margin-top: ${theme.space.sm};
        }
        margin-bottom: ${theme.space.lg};
        border: 0.4rem solid ${theme.colors.global.grey100};
        border-width: 0;
        border-radius: 4px 4px 4px;
        overflow: ${$isApplyExperimentStage ? 'visible' : 'hidden'};
        padding: 0;
        ${theme.breakpoints.mq.tabletMin} {
            padding: 0;
        }
    `}
`;
BaseStage.displayName = 'BaseStage';

export const TermsAndConditionsContainer = styled.div`
    ${({ theme }: any) => css`
        margin-top: ${theme.space.sm};
    `}
`;
TermsAndConditionsContainer.displayName = 'TermsAndConditionsContainer';

export const HeroParagraph = styled(Paragraph)`
    ${({ theme }: any) => css`
        margin-bottom: ${theme.space.sm};
    `};
    ${({ theme }: any) => css`
        ${theme.breakpoints.mq.tabletMin} {
            padding-left: ${theme.space.lg};
        }
    `}
`;
HeroParagraph.displayName = 'HeroParagraph';

export const GroupsWrapper = styled.div`
    ${({ theme }: any) => css`
        background-color: ${theme.colors.global.white};
        padding: ${theme.space.md} ${theme.space.sm};
        ${theme.breakpoints.mq.tabletMin} {
            padding: ${theme.space.lg};
        }
    `}
`;
GroupsWrapper.displayName = 'GroupsWrapper';

export const NoImpactModalTrigger = styled.span`
    ${({ theme }: any) => css`
        font-weight: ${theme.fontWeights.semiBold};
    `}
`;
NoImpactModalTrigger.displayName = 'NoImpactModalTrigger';

export const SkipStageButton = styled(Button)`
    ${({ theme }: any) => css`
        display: block;
        margin: ${theme.space.sm} auto 0;
    `}
`;
SkipStageButton.displayName = 'SkipStageButton';

export const VisuallyHiddenHeadingOne = styled(HeadingLevelOne)`
    ${VisuallyHidden}
`;
VisuallyHiddenHeadingOne.displayName = 'VisuallyHiddenHeadingOne';
